import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {LoginFormComponent} from './login-form.component';
import {ButtonModule} from '../button/button.module';
import {ErrorMessageModule} from '../error-message/error-message.module';
import {LoadingModule} from '../loading/loading.module';
import {FormDividerModule} from '../form-divider/form-divider.module';
import {ResetPasswordFormModule} from '../reset-password-form/reset-password-form.module';
import {CountrySelectModule} from '../country-select/country-select.module';
import {SelectMethodMessageModule} from '../select-method-message/select-method-message.module';
import {ValidateCodeModule} from '../validate-code/validate-code.module';
import {SelectEmailModule} from '../select-email/select-email.module';
import { BasicModalModule } from '../modals/basic-modal/basic-modal.module';
import { RegisterUserModule } from '../../../modals/register-user/register-user.module';

@NgModule({
  declarations: [LoginFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ButtonModule,
    ErrorMessageModule,
    LoadingModule,
    FormDividerModule,
    ResetPasswordFormModule,
    CountrySelectModule,
    SelectMethodMessageModule, 
    ValidateCodeModule,
    RegisterUserModule,
    SelectEmailModule,
    BasicModalModule
  ],
  exports: [LoginFormComponent],
})
export class LoginFormModule { }
